import { isOfflineEnabled, isOfflinePath } from '~/utils/isOffline';

export default defineNuxtRouteMiddleware((to) => {
    const offline = isOfflineEnabled(useRuntimeConfig().public.offline);
    const localePath = useLocalePath();
    const offlinePath = localePath('/offline');

    if (offline) {
        if (isOfflinePath(to.path)) {
            return;
        }

        return navigateTo(offlinePath);
    }

    if (isOfflinePath(to.path)) {
        return navigateTo(localePath('/'));
    }
});
